<template>
	<div style="width: 100%;">
		<div class="stateDiagram" style="margin-top: 0px;min-width: 1000px">
			<div class="sype_title">{{$t('label_176')}}</div>
			<div style="display: flex;">
				<div style="display: flex;align-items: center">
					<div style="width: 20px;height: 20px;margin-right: 5px" :style="{background:$store.getters.getColor['3'].color}"></div>
					<div style="margin-right: 10px">{{$t($store.getters.getColor['3'].description)}}</div>
				</div>
				<div style="display: flex;align-items: center">
					<div style="width: 20px;height: 20px;margin-right: 5px" :style="{background:$store.getters.getColor['2'].color}"></div>
					<div style="margin-right: 10px">{{$t($store.getters.getColor['2'].description)}}</div>
				</div>
				<div style="display: flex;align-items: center">
					<div style="width: 20px;height: 20px;margin-right: 5px" :style="{background:$store.getters.getColor['1'].color}"></div>
					<div>{{$t($store.getters.getColor['1'].description)}}</div>
				</div>
				<div style="display: flex;align-items: center;margin-right: 10px;">
					<div style="width: 20px;height: 20px;margin-right: 5px" :style="{background:$store.getters.getColor['0'].color}"></div>
					<div>{{$t($store.getters.getColor['0'].description)}}</div>
				</div>
				<div class="date_box" style="margin-right: 0px;">
					<el-date-picker v-model="date" align="right" type="date" :clearable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
					 :placeholder="$t('选择日期')" @change="changeDate" :picker-options="{disabledDate(time) {return time.getTime() > Date.now();}}">
					</el-date-picker>
					<i class="el-icon-arrow-left left" @click="calcDay(-1)"></i>
					<i class="el-icon-arrow-right right" @click="calcDay(1)"></i>
				</div>
			</div>

		</div>
		<div style="position: relative;max-height: 600px;min-width: 1000px">
			<!-- 性能分析图 -->
			<div class="deviceTime" style="width: 100%;height: 110px;border-bottom: 1px  solid #D9D9D9;margin-top:0px;" ref="timeChartWidth">
				<TimeChart v-if="pageChange" :chartsId="'deviceTime'+eqDetailInfo.id" :dataCode="eqDetailInfo.code" :dataName="eqDetailInfo.name"
				 :data="timeChartData[eqDetailInfo.id]" :beginTime="beginTime" :endTime="endTime"></TimeChart>
			</div>

			<!--下面内容-->
			<div class="box_down_all_style">
				<!--左边-->
				<div class="box_down_all_left">
					<div style="display: flex;width: 100%;padding: 10px 0 0px 0px;border-bottom: 1px solid #D9D9D9;box-sizing: border-box">
						<div>
							<div class="lft_box">{{$t('label_641')}}</div>
							<div id="mains" style="width: 90px;height: 90px;"></div>
							<div class="echart_style" style="width: 80px;height: 80px;float: left;">
							</div>
						</div>
						<div class="tableBox_aaaa" style="height: 100%;width:calc(100% - 90px);overflow: auto">
							<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" :header-cell-style="{'background-color': '#ffffff','color': '#000000',}"
							 highlight-current-row @current-change="handleCurrentChangeTree1" style="width: 100%;" height="156">
								<el-table-column property="state" :label="$t('label_412')" align="center" width="100">
									<template slot-scope="scope">
										<div class="conBox">
											<div class="secBox" :style="{'background':scope.row.color}"></div>
											<span style="margin-left: 5px;">{{$t(scope.row.name)}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column property="value" :label="$t('label_96')" align="center" width="90">
									<template slot-scope="scope">
										{{scope.row.value}}{{$t('label_647')}}
									</template>
								</el-table-column>
								<el-table-column property="count" :label="$t('label_207')" align="center" width="60">
								</el-table-column>
								<el-table-column property="Proportion" :label="$t('label_104')" align="center" width="100">
									<template slot-scope="scope">
										{{allTime==0?'--':parseFloat(Number(scope.row.value)*100/allTime).toFixed(0)}}%
									</template>
								</el-table-column>
							</el-table>
						</div>

					</div>
					<div>
						<div style="font-weight: bold;font-size: 18px;margin-top: 10px;">{{$t('label_926')}}</div>
						<div class="tableBox_two" style="width:calc(100% - 20px);font-size: 12px">
							<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData2" :header-cell-style="{'background-color': '#ffffff','color': '#000000',}"
							 highlight-current-row :show-header="false" @current-change="handleCurrentChangeTreeTime" :row-style="{height:'28px'}"
							 :cell-style="{padding:'0px'}" style="width: 100%;" height="calc(100% - 202px)">
								<el-table-column property="name" align="left">
								</el-table-column>
								<el-table-column property="statData" align="center">
								</el-table-column>
							</el-table>
						</div>
					</div>

				</div>
				<!--右边-->
				<div class="box_down_all_right">
					<div class="box_top" style="display: flex;  justify-content: space-between;">
						<div class="lft_text" style="margin-top: 10px;">{{$t('label_645')}}</div>
<!--						<div class="buttonBox" style="margin-top: 5px;">-->
<!--							<div class="chooseButton searchButton" @click="exportClick" style="margin-right: 10px;"><i class="el-icon-upload2"></i>{{$t('btn_10')}}</div>-->
<!--						</div>-->
					</div>
					<div class="sec_box" style="display: flex;margin-top: 5px;width: 100%;">
						<div class="secBox_one" v-for="(item,index) in statusNumList" :class="item.check==true?'check':''">
							<p :style="{'color':'#000000'}">{{$t(item.text)}}</p>
							<!-- <p :style="{'color':item.color}">{{item.text}}</p> -->
							<div class="checkBox" style="margin-right: 10px;">
								<el-checkbox v-model="item.check" :checked="item.check" :key="item.key" @change="search"></el-checkbox>
							</div>
						</div>
					</div>
					<div style="margin-top: 10px;width: 100%;height:350px;" class="table_box">
						<el-table :empty-text="$t('label_357')" ref="singleTable" :data="selectDataEventListList" highlight-current-row @current-change="handleCurrentChangeTree"
						 border style="width: 100%;margin: 10px 0" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
							<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="55">
							</el-table-column>
							<el-table-column prop="type" :label="$t('label_171')" align="left" width="110">
								<template slot-scope="scope">
									<div :style="{background:$store.getters.getColor['3'].color}" class="checkBoxs" v-if="scope.row.lastValue == 3"></div>
									<div :style="{background:$store.getters.getColor['2'].color}" class="checkBoxs" v-if="scope.row.lastValue == 2"></div>
									<div :style="{background:$store.getters.getColor['1'].color}" class="checkBoxs" v-if="scope.row.lastValue == 1"></div>
									<div :style="{background:$store.getters.getColor['0'].color}" class="checkBoxs" v-if="scope.row.lastValue == 0"></div>
									<div :style="{background:$store.getters.getColor['4'].color}" class="checkBoxs" v-if="scope.row.lastValue == 4"></div>
									<span style="list-style: none;float: left;margin-left: 5px;" v-if="scope.row.lastValue == 1">{{$t($store.getters.getColor['1'].description)}}</span>
									<span style="list-style: none;float: left;margin-left: 5px;" v-if="scope.row.lastValue == 2">{{$t($store.getters.getColor['2'].description)}}</span>
									<span style="list-style: none;float: left;margin-left: 5px;" v-if="scope.row.lastValue == 3">{{$t($store.getters.getColor['3'].description)}}</span>
									<span style="list-style: none;float: left;margin-left: 5px;" v-if="scope.row.lastValue == 0">{{$t($store.getters.getColor['0'].description)}}</span>
									<span style="list-style: none;float: left;margin-left: 5px;" v-if="scope.row.lastValue == 4">{{$t($store.getters.getColor['4'].description)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="startTime" :label="$t('label_181')" align="left" width="150">
								<template slot-scope="scope">
									{{scope.row.startTime}}<br />
									{{scope.row.endTime==null?$t('持续中'):scope.row.endTime}}<br />
									{{parseFloat(scope.row.duration/60).toFixed(0)+'(' + $t('label_647') + ')'}}
									<!-- {{tem}} -->
									<!-- {{scope.row.duration/60000+'(分)'}} -->
								</template>
							</el-table-column>
							<el-table-column prop="duration" :label="$t('label_682') + '(s)'" align="left" width="100">
								<template slot-scope="scope">
									{{scope.row.duration}}
								</template>
							</el-table-column>
							<el-table-column prop="dictContentKey" :label="$t('label_185')" align="left" width="140">
								<template slot-scope="scope">
									<el-select v-model="scope.row.dictContentKey" placeholder="">
										<el-option v-for="item in options" :key="item.key" :label="item.val" :value="item.key">
										</el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column prop="remark" :label="$t('btn_29')" align="left" style="width: 10px;">
								<template slot-scope="scope" style="width: 1px;">
									<el-input style="width: 118px;" v-model="scope.row.remark" clearable>
									</el-input>
									<el-button type="primary" style="margin-left: 4px;" @click="save(scope.row)">{{$t('btn_13')}}</el-button>
								</template>
							</el-table-column>
						</el-table>
						<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" style="width: 100%;height: 1px"
						 ref="exportBox"></exportMes>
					</div>
				</div>
				<div style="position: absolute;bottom: 0px;left: -6%;width: 100%;">
					<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
					 @parentMethod="searchPage"></Page>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import * as echarts from 'echarts';
	import TimeChart from '@/components/list/chart/timeChart';
	import Page from "@/components/common/pageNew2";
	// import "@/assets/css/map/map.css";
	// import "@/assets/css/common/spot.css";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils';
	import file from "@/assets/js/file/file.js";
	import exportMes from "@/components/list/export/export";
	import popMesBox from "@/components/list/popover/pop";
	import equipmentMonitoringService from "@/assets/js/signal/equipmentMonitoringService.js";

	export default {
		name: "daily",
		components: {
			Page,
			TimeChart,
			popMesBox,
			exportMes
		},
		props: {
			eqDetailInfo: {
				type: Object,
				default: {}
			},
			workTime: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
				pageChange: true,
				timeChartShow: true,
				allTime: 0,
				searchData: {
					beginTime: "",
					endTime: "",
					type: 1,
					id: 0,
					valueList: []
				},
				selectDataEventListList: [],
				date: '',
				beginTime: '',
				endTime: '',
				timeChartData: {},
				pageNum: 1,
				pageSize: 50,
				pageCount: 0,
				getNums: '',
				tableDataTreeInfo: {},
				tableDataTreeInfo1: {},
				tableChooseInfo: {},
				exportTitle: this.$t('label_645'),
				tableDataTreeTimeExport: [],
				exportList: [{
					column: 'lastValue',
					title: this.$t('label_171'),
					headerAlign: 'center',
					align: 'center',
					width: '100px'
				}, {
					column: 'startTime',
					title: this.$t('label_580'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'endTime',
					title: this.$t('label_585'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'duration',
					title: this.$t('label_682') + '(s)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'dictContentKey',
					title: this.$t('label_185'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'remark',
					title: this.$t('btn_29'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}],
				tableData1: [{
					color: '#3FB393',
					operatingCondition: this.$t('label_841'),
					runningTime1: '2021/08/18  09:38',
					runningTime2: '2022/04/24  15:01',
					duration: 86400,
				}, {
					color: '#FFCC00',
					operatingCondition: this.$t('label_842'),
					runningTime1: '2021/08/18  09:38',
					runningTime2: '2022/04/24  15:01',
					duration: 86400,
				}, {
					color: '#FE0000',
					operatingCondition: this.$t('label_843'),
					runningTime1: '2021/08/18  09:38',
					runningTime2: '2022/04/24  15:01',
					duration: 86400,
				}, {
					color: '#AEAEAE',
					operatingCondition: this.$t('label_844'),
					runningTime1: '2021/08/18  09:38',
					runningTime2: '2022/04/24  15:01',
					duration: 86400,
				}, {
					color: '#3FB393',
					operatingCondition: this.$t('label_841'),
					runningTime1: '2021/08/18  09:38',
					runningTime2: '2022/04/24  15:01',
					duration: 86400,
				}, {
					color: '#3FB393',
					operatingCondition: this.$t('label_841'),
					runningTime1: '2021/08/18  09:38',
					runningTime2: '2022/04/24  15:01',
					duration: 86400,
				}],
				tableData2: [{
					name: this.$t('label_677') + '(' + this.$t('label_647') + '):',
					statData: '--'
				}, {
					name: this.$t('label_198') + '(' + this.$t('label_647') + '):',
					statData: '--'
				}, {
					name: this.$t('label_191') + '(%):',
					statData: '--'
				}, {
					name: this.$t('label_675') + '(' + this.$t('label_647') + '):',
					statData: '--'
				}, {
					name: this.$t('label_202') + '(' + this.$t('label_207') + '):',
					statData: '--'
				}, {
					name: this.$t('label_673') + '(' + this.$t('label_647') + '):',
					statData: '--'
				}, {
					name: this.$t('平均故障间隔时长') + '(' + this.$t('label_647') + '):',
					statData: '--'
				}, {
					name: this.$t('label_671') + '(' + this.$t('label_647') + '):',
					statData: '--'
				}, {
					name: this.$t('label_669') + ':',
					statData: '--'
				}],
				tableData: [{
					color: '#3FB393',
					state: this.$t('label_841'),
					duration: '523分',
					frequency: 17,
					Proportion: '68%'
				}, {
					color: '#FFCC00',
					state: this.$t('label_842'),
					duration: '168分',
					frequency: 17,
					Proportion: '28%'
				}, {
					color: '#FE0000',
					state: this.$t('label_843'),
					duration: '0分',
					frequency: 0,
					Proportion: '1%'
				}, {
					color: '#AEAEAE',
					state: this.$t('label_844'),
					duration: '0分',
					frequency: 0,
					Proportion: '3%'
				}],
				statusNumList: [{
						text: this.$store.getters.getColor['3'].description,
						color: this.$store.getters.getColor['3'].color,
						check: true,
						key: '3',
					},
					{
						text: this.$store.getters.getColor['2'].description,
						color: this.$store.getters.getColor['2'].color,
						check: true,
						key: '2',
					},
					{
						text: this.$store.getters.getColor['1'].description,
						color: this.$store.getters.getColor['1'].color,
						check: true,
						key: '1',
					},
					{
						text: this.$store.getters.getColor['0'].description,
						color: this.$store.getters.getColor['0'].color,
						check: true,
						key: '0',
					}
				],
				options: [],
			}
		},
		methods: {
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			getWord(value) {
				this.getWords = value
			},
			handleEdit(index, row) {
				// console.log(index, row);
			},
			exportClick() {
				// this.$refs.exportBox.setExportExcel();
				window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMonitoringService/excel?' + utils.urlSplit(
					this.searchData);
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTree1(info) {
				this.tableDataTreeInfo1 = info;
			},
			handleCurrentChangeTreeTime(info) {
				this.tableChooseInfo = info;
			},
			statusType() {
				equipmentMonitoringService.statusType().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.options = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			save(data) {
				equipmentMonitoringService.update(data).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.$message({
							message: this.$t('msg_21'),
							type: 'success'
						});
						let param = {
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						}
						this.searchPage(param)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			//查询列表数据
			search() {
				//开始时间
				this.searchData.beginTime = this.beginTime;
				//结束时间
				this.searchData.endTime = this.endTime;
				//设备ID
				this.searchData.id = this.eqDetailInfo.id;
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param)
			},
			searchPage(param) {
				this.searchData.valueList = []
				for (let i = 0; i < this.statusNumList.length; i++) {
					if (this.statusNumList[i].check == true) {
						this.searchData.valueList.push(this.statusNumList[i].key);
					}
				}
				if (this.searchData.valueList.length == 0) {
					this.$message({
						message: this.$t('msg_53'),
						type: 'error'
					});
					return
				}
				let dataParam = this.searchData;
				let newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.$refs['pageModel'].setCurrent(this.pageNum);
				this.selectDataEventList(newParam);
				// this.selectDataEventExcel(newParam);
			},
			selectDataEventList(param) {
				equipmentMonitoringService.selectDataEventList(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.selectDataEventListList = data.data.list;
						this.pageNum = data.data.pageNum;
						this.pageCount = data.data.total;
						this.pageSize = data.data.pageSize == 0 ? data.data.size : data.data.pageSize;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectDataEventExcel(param) {
				equipmentMonitoringService.selectDataEventExcel(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTimeExport = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			// searchPage(param) {
			// 	SpotCheck.getCheckCount(param).then((response) => {
			// 		const data = response.data;
			// 		if (data.code == "1") {
			// 			this.tableDataTreeTime = data.data.records
			// 			// for (let q = 0; q < this.tableDataTreeTime.length; q++) {
			// 			// 	this.tableDataTreeTime[q].tName = '';
			// 			// 	this.tableDataTreeTime[q].dName = '';
			// 			// 	for (let i = this.tableDataTreeTime[q].typeName.length - 2; i >= 0; i--) {
			// 			// 		this.tableDataTreeTime[q].tName += this.tableDataTreeTime[q].typeName[i] + ' ';
			// 			// 	}
			// 			// 	this.tableDataTreeTime[q].tName += this.tableDataTreeTime[q].typeName[this.tableDataTreeTime[q].typeName.length - 1]
			// 			// 	for (let i = this.tableDataTreeTime[q].deptName.length - 1; i >= 0; i--) {
			// 			// 		this.tableDataTreeTime[q].dName += this.tableDataTreeTime[q].deptName[i] + ' ';
			// 			// 	}
			// 			// }
			// 			this.pageSize = data.data.size;
			// 			this.pageCount = data.data.total;
			// 			this.pageNum = data.data.current;
			// 			this.$refs['pageModel'].setCurrent(this.pageNum);
			// 		}
			// 	}).catch((response) => {
			// 		console.log(response)
			// 	})
			// },
			selectTime() {
				let param = [this.eqDetailInfo]
				this.timeChartShow = false;
				equipmentMonitoringService.selectTime(param, this.beginTime, this.endTime).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.timeChartData = data.data;
						// console.log(this.$refs.timeChartWidth)
						this.timeChartShow = true;
					};
				}).catch((response) => {
					console.log(response)
				})
			},
			myEchartss() {
				let param = {
					beginTime: this.beginTime,
					endTime: this.endTime,
					id: this.eqDetailInfo.id,
					type: 1
				}
				equipmentMonitoringService.selectDayPie(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData2 = [{
							name: this.$t('label_677') + '(' + this.$t('label_647') + '):',
							statData: data.data.workTime
						}, {
							name: this.$t('label_198') + '(' + this.$t('label_647') + '):',
							statData: data.data.loadTime
						}, {
							name: this.$t('label_191') + '(%):',
							statData: (data.data.activation > 100 ? 100 : data.data.activation)
						}, {
							name: this.$t('label_675') + '(' + this.$t('label_647') + '):',
							statData: data.data.shutdownTime
						}, {
							name: this.$t('label_202') + '(' + this.$t('label_207') + '):',
							statData: data.data.shutdownCount
						}, {
							name: this.$t('label_673') + '(' + this.$t('label_647') + '):',
							statData: data.data.maxShutdownTime
						}, {
							name: this.$t('平均故障间隔时长') + '(' + this.$t('label_647') + '):',
							statData: data.data.intervalTime
						}, {
							name: this.$t('label_671') + '(' + this.$t('label_647') + "):",
							statData: data.data.recoverTime
						}, {
							name: this.$t('label_669') + ':',
							statData: data.data.manufacture
						}];
						let pieData = [];
						let pieColor = [];
						let all = 0;
						for (let a of data.data.list) {
							all += Number(a.value);
							pieData.push({
								value: Number(a.value),
								name: this.$t(a.name)
							})
							pieColor.push(a.color);
						}
						this.allTime = all;
						this.tableData = data.data.list;
						let chartDom = document.getElementById('mains');
						let myChart = echarts.init(chartDom);
						let option = {
							tooltip: {
								show: false, //关闭鼠标移上去后显示浮框信息
								trigger: 'item'
							},
							color: pieColor,
							series: [{
								hoverAnimation: false, //关闭放大动画
								name: this.$t('label_641'),
								type: 'pie',
								radius: '80%',
								center: ["50", "50%"],
								data: pieData,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									}
								},
								label: {
									show: false
								},
								clockwise: false, //生长方向，是否顺时针
							}]
						};
						option && myChart.setOption(option);
					};
				}).catch((response) => {
					console.log(response)
				})
			},

			//性能分析图
			renderItem(params, api) {
				let categoryIndex = api.value(0); //这里使用 api.value(0) 取出当前 dataItem 中第一个维度的数值。
				let start = api.coord([api.value(1), categoryIndex]); // 这里使用 api.coord(...) 将数值在当前坐标系中转换成为屏幕上的点的像素值
				let end = api.coord([api.value(2), categoryIndex]); // 这里使用 api.coord(...) 将数值在当前坐标系中转换成为屏幕上的点的像素值
				// let height = api.size([0, 1])[1] * 0.8; // 这里使用 api.size(...) 获得 Y 轴上数值范围为 1 的一段所对应的像素长度。控制柱形大小
				let height = api.size([0, 1])[1]; // 这里使用 api.size(...) 获得 Y 轴上数值范围为 1 的一段所对应的像素长度。控制柱形大小
				let rectShape = echarts.graphic.clipRectByRect({ //矩形的位置和大小
						x: start[0],
						y: start[1] - height / 2,
						width: end[0] - start[0],
						height: height
					},
					//当前坐标系的包围盒
					{
						x: params.coordSys.x,
						y: params.coordSys.y,
						width: params.coordSys.width,
						height: params.coordSys.height
					});
				return (
					// 这里返回为这个 dataItem 构建的图形元素定义。
					rectShape && {
						type: 'rect', // 表示这个图形元素是矩形。还可以是 'circle', 'sector', 'polygon' 等等。
						transition: ['shape'], //横向柱状堆叠图
						shape: rectShape,
						style: api.style() // 用 api.style(...) 得到默认的样式设置。这个样式设置包含了option 中 itemStyle 的配置和视觉映射得到的颜色。
					}
				);
			},
			calcDay(i) {
				let d = new Date(this.date).getTime() + 1000 * 60 * 60 * 24 * i;
				if (d > Date.now()) {
					return;
				}
				let date = new Date(d);
				this.date = date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate());
				this.changeDate();
			},
			nextDay(date) {
				let d = new Date(date).getTime() + 1000 * 60 * 60 * 24;
				date = new Date(d);
				return date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate());
			},
			zero(i) {
				return i > 9 ? i : '0' + i;
			},
			refresh() {
				utils.clearTime();
				this.selectTime() //运转状况图
				this.search() //运转状态列表
				this.myEchartss() //运转信息&统计信息
				//定时查询当天数据
				if (this.date == utils.getDayFormatDate()) {
					var $this = this;
					utils.timing(function() {
						$this.selectTime() //运转状况图
						$this.search() //运转状态列表
						$this.myEchartss() //运转信息&统计信息
					}, 10000)
				}
			},
			changeDate() {
				//计算开始和结束时间
				if (this.workTime.beginTimeOverDay == 0) {
					this.beginTime = this.date + this.workTime.beginTime.substring(10);
				} else {
					this.beginTime = this.nextDay(this.date) + this.workTime.beginTime.substring(10);
				}
				if (this.workTime.endTimeOverDay == 0) {
					this.endTime = this.date + this.workTime.endTime.substring(10);
				} else {
					this.endTime = this.nextDay(this.date) + this.workTime.endTime.substring(10);
				}
				this.refresh();
			}

		}, //methods的闭合
		mounted() {
			this.refresh();
		},
		created() {
			this.statusType();
			this.date = utils.getDayFormatDate();
			this.beginTime = this.workTime.beginTime;
			this.endTime = this.workTime.endTime;
		},
		beforeDestroy() {
			utils.clearTime();
		}
	}
</script>

<style>
	.date_box {
		position: relative;
		float: right;
	}

	.date_box .el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 160px;
	}

	.date_box .el-input--prefix .el-input__inner {
		padding-left: 52px;
	}

	.date_box .left {
		position: absolute;
		left: 30px;
		top: 12px;
		cursor: pointer;
	}

	.date_box .right {
		position: absolute;
		left: 130px;
		top: 12px;
		cursor: pointer;
	}



	.stateDiagram {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 0px;
	}

	.box_down_all_style {
		display: flex;
	}

	.box_down_all_left {
		width: 35%;
		border-bottom: 1px solid #EFEFEF;
	}

	.box_down_all_right {
		width: 64%;
		padding-left: 1%;
	}

	.tableBox_aaaa {
		margin-top: 2px;
	}

	.tableBox_two {
		margin-left: 20px;
		width: 400px;

	}

	.tableBox_two .el-table td,
	.tableBox_two .el-table th {
		padding: 5px;
	}

	.tableBox_aaaa .el-table td,
	.tableBox_aaaa .el-table th {
		padding: 1px;
	}

	.lft_box {
		font-size: 18px;
		font-weight: bold;

	}

	.lft_text {
		font-size: 18px;
		font-weight: bold;
		margin-top: 10px;
		margin-left: 0px;
	}

	.sype_title {
		font-size: 18px;
		font-weight: bold;
		margin-left: 0px;
	}

	.tablebox_down {
		width: 40%;
	}

	.sec_box .secBox_one.check {
		border: 1px solid #3fb393;
	}

	.sec_box .secBox_one {
		border: 1px solid #DADADA;
		background: #EFEFEF;
		width: 22%;
		height: 40px;
		margin-left: 25px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.secBox_one p {
		padding-left: 10px;
		line-height: 40px;
		font-weight: bold;
	}

	.checkBox {
		margin-right: 10px;
	}

	.group-inp {
		width: 100px;
	}

	.secBox {
		width: 10px;
		height: 10px;
	}

	.conBox {
		display: flex;
		align-items: center;
	}

	.secBox_one {
		display: flex;
		width: 15px;
		height: 15px;
		margin-top: 5px;
	}

	.table_box .el-table td,
	.table_box .el-table th {
		padding: 3px;
		font-size: 10px;

	}
</style>



// WEBPACK FOOTER //
// src/components/list/equipmentDetails/daily.vue